import React from 'react';
import { ArrowLeft, Hash, Volume2, VolumeX } from 'lucide-react';
import { initials } from '@/utils/commsFormat';

export const ThreadHeader = ({ conversation: c, onBack, onToggleMute }) => {
  const isTeam = c.kind === 'team';
  const subtitle = isTeam
    ? `${c.online_count} of ${c.member_count} online`
    : c.is_bot ? 'Reminders from your AI chat · read-only'
      : c.online ? 'Online' : 'Offline · messages will be delivered when they return';

  return (
    <div className="thread-head">
      <button type="button" className="icon-btn thread-back" onClick={onBack} aria-label="Back to conversations" data-testid="back-to-contacts">
        <ArrowLeft size={18} />
      </button>
      <div className={`avatar small ${isTeam ? 'team' : ''}`}>
        {isTeam ? <Hash size={16} /> : c.picture ? <img src={c.picture} alt="" /> : initials(c.name)}
        {!isTeam && !c.is_bot && <span className={`presence ${c.online ? 'online' : ''}`} />}
      </div>
      <div className="thread-head-text">
        <div className="thread-name" data-testid="thread-contact-name">{isTeam ? `# ${c.name}` : c.name}</div>
        <div className="thread-sub" data-testid="thread-contact-status">{subtitle}</div>
      </div>
      {isTeam && (
        <button
          type="button"
          className={`icon-btn mute-btn ${c.muted ? 'muted' : ''}`}
          onClick={() => onToggleMute(c.id)}
          aria-pressed={c.muted}
          title={c.muted ? 'Radio muted on this device · tap to unmute' : 'Mute radio playback for this channel on this device'}
          data-testid="channel-mute-toggle"
        >
          {c.muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
        </button>
      )}
    </div>
  );
};
